<template>
  <div
    class="company-box"
    @mouseenter="onMouseEnter"
    @mouseleave="onMouseLeave"
  >
    <div v-show="isHover" class="hover-card">
      <div class="hover-card-name">{{ compName }}</div>
      <div class="hover-card-num">
        共
        <span style="color: #29bdb9; font-weight: blod"
          >{{ item.questionCount }} </span
        >道题
      </div>
      <a class="btn" @click="onClick" style="padding: 2px 15px">我要作答</a>
    </div>
    <div class="company-box-card" slot="reference">
      <div class="company-box-bd">
        <div class="paper-title">
          <div>{{ item.afterTitle }}</div>
          <div>{{ item.positionTitle }}</div>
        </div>

        <div class="student_num">
          已有<span>{{ item.basePractiseCount }}人</span>完成作答
        </div>
      </div>

      <div class="company-box-ft">
        <div class="company-box-ft-img">
          <img :src="compLogo" />
        </div>
      </div>
    </div>
    <answered
      :dialogVisible="dialogVisible"
      @onCancel="onCancel"
      @goExam="goExam"
      :guid="guid"
    ></answered>
  </div>
</template>
<script>
import answered from '../answered'
import { LOGIN_API } from "@/api.js";
export default {
  name: 'company-code-box',
  components: {
    answered,
  },
  data() {
    return {
      isHover: false,
      compCode: '',
      login: false,

      url: '',
      guid: '',
      dialogVisible: false,
    }
  },
  computed: {
    loginStatus() {
      return this.$store.state.app.login //需要监听的数据
    },
  },
  props: ['item', 'compLogo', 'compName'],
  mounted() {
    this.compCode = this.$route.query.compCode
  },
  methods: {
    onCancel() {
      this.dialogVisible = false
    },
    onMouseEnter(e) {
      this.isHover = true
    },
    onMouseLeave() {
      this.isHover = false
    },
    redirectUrl(url, mobile) {
      const token = this.$cookies.get('client_token')
      if (url.indexOf('tencent1') > -1) {
        location.href =
          url + '&r=auto' + '&m=' + mobile + '&token=' + token.token
        return
      }
      location.href = url + '&r=auto' + '&m=' + mobile + '&token=' + token.token
    },
    onClick() {
      if (!this.loginStatus) {
        this.$bus.emit('checkUserLogin')
        return
      }
      let post = {
        positionId: this.item._id,
        compCode: this.compCode,
      }
      this.$axios
        .post(`${LOGIN_API}/customer/api/myLastTest`, post)
        .then((res) => {
          if (res.data.errno == 0) {
            if (res.data.data && res.data.data.length > 0) {
              const list = res.data.data
              this.guid = list[list.length - 1].guid
              this.dialogVisible = true
            } else {
              this.goExam()
            }
          } else {
              if(res.data.errno == 98){
                //FIXME - 如果接口是过期了 98 接口错误是“同学，请先登录再继续操作”，直接引导重新登录
                this.resetLogin()
              }else{
                res.data.errmsg ? this.$message.error(res.data.errmsg) : null
              }
          }
        })
    },
    goExam() {
      if (!this.loginStatus) {
        this.$bus.emit('checkUserLogin')
        return
      }
      let post = {
        compCode: this.compCode,
        positionId: this.item._id,
      }
      this.$axios
        .post(`${LOGIN_API}/customer/api/enterExam`, post)
        .then((res) => {
          if (res.data.errno == 0) {
            if (res.data.result.mobile && res.data.result.url) {
              this.redirectUrl(res.data.result.url, res.data.result.mobile)
            }
          } else {
              if(res.data.errno == 98){
                //FIXME - 如果接口是过期了 98 接口错误是“同学，请先登录再继续操作”，直接引导重新登录
                this.resetLogin()
              }else{
                res.data.errmsg ? this.$message.error(res.data.errmsg) : null
              }
          }
        })
    },
      //NOTE - token过期 
      resetLogin(){
        this.$store.dispatch('setLogin', false)
        this.$cookies.remove('client_token')
        this.$cookies.remove('hr_token')
        this.$axios.defaults.headers.common['authorization'] = null
        this.$bus.emit('checkUserLogin')
    },
  },
}
</script>
<style lang="scss" scoped>
.company-box {
  position: relative;
  width: 210px;
  height: 220px;
  border: 1px solid #eff0f2;
  margin-right: 20px;
  margin-bottom: 20px;
  display: inline-block;
  font-size: 14px;
  color: #333;
  overflow: hidden;
  .hover-card {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    text-align: center;
    background: #fff;
    z-index: 101;
    box-shadow: #eff0f2 0px 2px 12px 6px;
    .hover-card-name {
      color: #29bdb9;
      font-size: 20px;
      font-weight: 400;
      padding-top: 40px;
    }
    .hover-card-num {
      display: block;
      font-size: 14px;
      padding: 28px 0;
      color: #666;
    }
  }
  .company-box-card {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
    background: #f8f9fb;
    cursor: pointer;
    .company-box-bd {
      text-align: center;
      width: 100%;
      padding-top: 24px;
      .paper-title {
        font-size: 14px;
        color: #333;
        text-align: center;
        font-weight: 400;
        padding-top: 34px;
        padding: 0px 15px;
        min-height: 50px;
      }
      .student_num {
        font-size: 14px;
        color: #666;
        text-align: center;
        font-weight: 400;
        padding: 14px 0 24px 0;
        span {
          color: #29bdb9;
        }
      }
    }
    .company-box-ft {
      background-color: #fff;
      text-align: center;
      height: 70px;
      position: absolute;
      width: 100%;
      bottom: 0px;
      vertical-align: middle;
      display: grid;
      .company-box-ft-img {
        height: 50px;
        width: 100%;
        margin-top: 10px;
        img {
          max-width: 180px;
          max-height: 50px;
          margin: auto;
        }
      }
      .company-box-ft-index {
        display: flex;
        padding-bottom: 10px;
        padding-left: 30px;
        margin: auto;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/practice/company-code-box/index.vue